module.exports = __webpack_public_path__ + "fonts/d63f77e2-a23d-496f-bc30-c61c7a689aa6.0a12e57.eot";